<ng-container *transloco="let t">
  <div class="rtg-finding" [formGroup]="form">
    <div class="field">
      <label class="label">{{ t('rtg.previousAnalyses') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea
          matInput
          formControlName="previousAnalyses"
          rows="3"
        ></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('rtg.anamnesis') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="anamnesis" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('rtg.clinicalFinding') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea
          matInput
          formControlName="clinicalFinding"
          rows="3"
        ></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('rtg.uzFinding') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="uzFinding" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('rtg.rtgInterpretation') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea
          matInput
          formControlName="rtgInterpretation"
          rows="3"
        ></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('rtg.rtgDiagnosis') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="rtgDiagnosis" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('rtg.therapy') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="therapy" rows="3"></textarea>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput formControlName="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
